function updateTextThemeMode(value) {
  const btnTheme = document.getElementById('btn-theme-footer');
  if (!btnTheme) return;

  btnTheme.textContent = value;
}

function toggleThemeMode() {
  const theme = document.documentElement.getAttribute('data-theme');
  if (!theme) return;

  if (theme === 'dark') {
    document.documentElement.setAttribute('data-theme', 'light');
    localStorage.setItem('theme', 'light');
    updateTextThemeMode('Darkmode');
  } else {
    document.documentElement.setAttribute('data-theme', 'dark');
    localStorage.setItem('theme', 'dark');
    updateTextThemeMode('Lightmode');
  }
}

function setupListenersThemeMode() {
  const btnTheme = document.getElementById('btn-theme-footer');

  if (btnTheme) {
    btnTheme.addEventListener('click', toggleThemeMode);
  }

  const btnThemeMenu = document.getElementById('btn-theme-menu');

  if (btnThemeMenu) {
    btnThemeMenu.addEventListener('click', toggleThemeMode);
  }
}

setupListenersThemeMode();

function setupListenersColdUri() {
  const elements = document.querySelectorAll('[data-uri]');

  elements.forEach((element) => {
    element.addEventListener('click', (event) => {
      const element = event.target.closest('[data-uri]');
      if (!element) return;

      const uri = element.dataset.uri;
      const url = atob(uri);
      if (url.match(/^https?:\/\//)) {
        window.open(url, '_blank', 'noopener noreferrer');
      } else window.location.href = url;
    });
  });
}

setupListenersColdUri();

(function () {
  const theme = localStorage.getItem('theme');
  if (theme === 'light') {
    updateTextThemeMode('Darkmode');
  }
})();
